import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { RotatableProgress } from "../RotatableProgress";
import { useMount } from 'ahooks';
import { message } from 'antd';
import React, { useState } from 'react';
import { Translator } from "./translator";
export var LongJobIndicator = function LongJobIndicator(properties) {
  var _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    currentAmount = _useState2[0],
    setCurrentAmount = _useState2[1];
  var _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    totalAmount = _useState4[0],
    setTotalAmount = _useState4[1];
  useMount(function () {
    // -
    properties.tipBridge.port2.addEventListener('message', function (event) {
      switch (event.data.code) {
        case 'TaskCountUpdatedEvent':
          {
            // -
            setTotalAmount(event.data.data);
            // -
            break;
          }
        case 'TaskStatusUpdatedEvent':
          {
            // -
            setCurrentAmount(event.data.data + 1);
            // -
            break;
          }
      }
    });
    // -
    // > -
    properties.tipBridge.port1.start();
    // > -
    properties.tipBridge.port2.start();
  });
  return /*#__PURE__*/React.createElement(RotatableProgress, {
    size: 16,
    percent: currentAmount / totalAmount * 100
  });
};
export var LongJob = /*#__PURE__*/function () {
  function LongJob() {
    _classCallCheck(this, LongJob);
  }
  _createClass(LongJob, null, [{
    key: "run",
    value: function run(title) {
      // 初始化上下文
      // > -
      var tasks = [];
      // > -
      var tipBridge = new MessageChannel();
      // > -
      var tipKey = String(Math.random());
      // > -
      var wrapTask = function wrapTask(task) {
        // 记录数据
        tasks.push(task);

        // 广播信息
        tipBridge.port1.postMessage({
          code: 'TaskCountUpdatedEvent',
          data: tasks.length
        });

        // 返回数据
        // > -
        task.then = new Proxy(task.then, {
          apply: function apply(target, thisArg, argArray) {
            // -
            if (argArray[0]) {
              argArray[0] = new Proxy(argArray[0], {
                apply: function apply(target0, thisArg0, argArray0) {
                  // -
                  tipBridge.port1.postMessage({
                    code: 'TaskStatusUpdatedEvent',
                    data: tasks.findIndex(function (task0) {
                      return task0 === task;
                    })
                  });
                  // -
                  return Reflect.apply(target0, thisArg0, argArray0);
                }
              });
            }
            // -
            return wrapTask(Reflect.apply(target, thisArg, argArray));
          }
        });
        // > -
        return task;
      };

      // 发送通知
      message.loading({
        content: Translator.formatMessage({
          id: '{title} in progress'
        }, {
          title: title
        }),
        key: tipKey,
        duration: -1,
        icon: /*#__PURE__*/React.createElement(LongJobIndicator, {
          tipBridge: tipBridge
        })
      });

      // 定时
      setTimeout(function () {
        var _tasks$at;
        (_tasks$at = tasks.at(-1)) === null || _tasks$at === void 0 || _tasks$at.then(function (value) {
          // -
          message.success({
            content: Translator.formatMessage({
              id: '{title} successfully completed'
            }, {
              title: title
            }),
            key: tipKey
          });
          // -
          return value;
        }, function (error) {
          // -
          message.error({
            content: Translator.formatMessage({
              id: '{title} failed'
            }, {
              title: title
            }),
            key: tipKey
          });
          // -
          throw error;
        });
      }, 0);

      // 返回根任务
      return wrapTask(Promise.resolve());
    }
  }]);
  return LongJob;
}();
export var Operator = LongJob;